export const CRM_OPEN_TABS = 'CRM_OPEN_TABS'; // 用户打开的TAB
export const CRM_CURRENT_TAB = 'CRM_CURRENT_TAB'; // 用户打开的当前TAB
export const CRM_MENU = 'CRM_MENU'; // 用户菜单
export const CRM_USER_INFO = 'CRM_USER_INFO'; // 用户信息
export const CRM_TOKEN = 'CRM_TOKEN'; // 用户TOKEN
export const CRM_CURRENT_SUBMENU = 'CRM_CURRENT_SUBMENU'; // 当前二级菜单
export const CRM_CURRENT_LEVEL_ONE_MENU = 'CRM_CURRENT_LEVEL_ONE_MENU'; // 当前一级菜单
export const CRM_ORDER_PAGEID = '10000'; // 报名=> 订单
export const CRM_CLUES_TRACKING = '10001'; // 客户跟进
export const CRM_CLUES_DETAILS = '10002'; // 客户详情
export const CRM_USER_DEPARTMENT = 'CRM_USER_DEPARTMENT'; // 人员信息
export const CRM_USER_CRTREE = 'CRM_USER_CRTREE'; // CR人员树
export const CRM_USER_TMKTREE = 'CRM_USER_TMKTREE'; // TMK人员数
export const CRM_USER_CCTREE = 'CRM_USER_CCTREE'; // CC人员数
export const CRM_USER_SALESMAN = 'CRM_USER_SALESMAN'; // 电销人员数
export const CRM_WECHATID = 'CRM_WECHATID'; // 微信ID

export const CRM_CUSTOMER_TYPE = 'CRM_CUSTOMER_TYPE'; // 客户类型
export const CRM_PROVICE_CITY = 'CRM_PROVICE_CITY'; // 获取城市
export const CRM_CLUES_STATUS = 'CRM_CLUES_STATUS'; // 客户状态
export const CRM_INTENTION_DEGREE = 'CRM_INTENTION_DEGREE'; // 感兴趣的项目
export const CRM_CUSTONER_SOURE = 'CRM_CUSTONER_SOURE'; // 客户来源
export const CRM_CHANNERLS = 'CRM_CHANNERLS'; // 有效渠道
export const CRM_RECOMMEND_CHANNERLS = 'CRM_RECOMMEND_CHANNERLS'; // 来源渠道
export const CRM_CLUES_OPTIMAL = 'CRM_CLUES_OPTIMAL'; // 优质客户
export const CRM_PROFESSIONAL_STATUS = 'CRM_PROFESSIONAL_STATUS'; // 职业状态
export const CRM_TRAFFIC_STATUS = 'CRM_TRAFFIC_STATUS'; // 话务状态
export const CRM_LABE_LIST = 'CRM_LABE_LIST'; // 关联标签
export const CRM_URGENCY = 'CRM_URGENCY'; // 沟通紧急度
export const CRM_SATISFACTION= 'CRM_SATISFACTION'; // 客户意向
export const CRM_INTENTTION_DEGREE = 'CRM_INTENTTION_DEGREE'; // 客户意向
export const CRM_CERTIFICATES_TYPE = 'CRM_CERTIFICATES_TYPE'; // 证件类型
export const CRM_INTENTION_STUDENTS = 'CRM_INTENTION_STUDENTS'; // 客户意向
export const CRM_LATEST_AJAX_TIME = 'CRM_LATEST_AJAX_TIME'; // 签入签出状态
export const CRM_SEX = 'CRM_SEX'; // 性别
export const CRM_PROJECT = 'CRM_PROJECT'; // 学科
export const CRM_GRADE = 'CRM_GRADE'; // 年级
export const CRM_STAGE = 'CRM_STAGE'; // 学段
export const CRM_COURSEFORM = 'CRM_COURSEFORM'; // 授课形式
export const CRM_LOCATION = 'CRM_LOCATION'; // 授课形式
export const CRM_LEAD_LOCATION = 'CRM_LEAD_LOCATION_V2'; // Leads国家地区
export const CRM_AUDITION_STATE = 'CRM_AUDITION_STATE'; // 试听状态
export const CRM_EXAMINE_STATE = 'CRM_EXAMINE_STATE'; // 审核状态
export const CRM_HOT = 'CRM_HOT'; // 预约试听热度
export const CRM_REFERRAL= 'CRM_REFERRAL'; // 预约试听热度
export const CRM_TMKAllot_TYPE = 'CRM_TMKAllot_TYPE'; // TMK分配配置类型
export const CRM_TMKAllot_RULETYPE = 'CRM_TMKAllot_RULETYPE'; // TMK分配配置规则类型
export const CRM_SCHOOLNATURE = 'CRM_SCHOOLNATURE'; // 校区性质
export const CRM_DURATION = 'CRM_DURATION'; // 试听课时长
export const CRM_USER_CONTRACTSTATUS = 'CRM_USER_CONTRACTSTATUS'; // 合同状态
export const CRM_SUBORDINATE_UNIST = 'CRM_SUBORDINATE_UNIST'; // 管理工作台二级部门

export const CRM_BOARDING = 'CRM_BOARDING'; // 寄宿情况
export const CRM_RANGENUMBER = 'CRM_RANGENUMBER'; // 学生总人数
export const CRM_MARKET = 'CRM_MARKET'; // 市调状态

// Range number




export const PANGU_SALE_LEVEL = 'PANGU_SALE_LEVEL' // 销售等级
export const PANGU_GROUP_LEVEL = 'PANGU_GROUP_LEVEL' // 销售组别
export const PANGU_VENUE_MEET = 'PANGU_VENUE_MEET' // 营销会议
export const PANGU_INVITE_STATUS = 'PANGU_INVITE_STATUS' // 会议邀约状态
export const PANGU_ATTEND_STATUS = 'PANGU_ATTEND_STATUS' // 会议出席状态
export const PANGU_ROOM_STYLE = 'PANGU_ROOM_STYLE' // 入住房型
export const PANGU_TRIP_MODE = 'PANGU_TRIP_MODE' // 到达方式
export const PANGU_SIGININ_STATUS = 'PANGU_SIGININ_STATUS' // 到达方式
export const PANGU_AREA_LEVEL = 'PANGU_AREA_LEVEL' // 产品地域等级
export const PANGU_SIGIN_STATUS = 'PANGU_SIGIN_STATUS' // 签到状态
export const PANGU_EFFECT_LIST = 'PANGU_EFFECT_LIST' // 影响力列表
export const PANGU_DISTRICT_STATUS = 'PANGU_DISTRICT_STATUS' // 片区状态
export const PANGU_USER_DEPARTMENT = 'PANGU_USER_DEPARTMENT' // 部门树
// export const PANGU_ORDER_EARNEST = 'PANGU_ORDER_EARNEST' // 新订单是否定金

export const PANGU_SCALELIST = 'PANGU_SCALELIST' // 学校规模列表
export const PANGU_ENVIRONLIST = 'PANGU_ENVIRONLIST' // 学校环境列表
export const PANGU_AREALIST = 'PANGU_AREALIST' // 学校面积列表
export const PANGU_CLASSROOM_SURVEY = 'PANGU_CLASSROOM_SURVEY' // 学校概况列表
export const PANGU_SCHOOLSTU_CNT = 'PANGU_SCHOOLSTU_CNT' // 在校生数列表
export const PANGU_CLASSSTU_CNT = 'PANGU_CLASSSTU_CNT' // 每班人数列表

export const PANGU_Intended_LEVEL = 'PANGU_Intended_LEVEL'; // 适用人群
export const PANGU_INTENDEND_ROLE = 'PANGU_INTENDEND_ROLE'; // 角色
export const PANGU_ARTiILE_TYPE = 'PANGU_ARTiILE_TYPE'; // 文章类型
export const PANGU_VISITING_STATUS = 'PANGU_VISITING_STATUS'; // 到访状态
export const PANGU_VISITING_STORE = 'PANGU_VISITING_STORE'; // 到访门店


export const PANG_KICK_POOL = 'PANG_KICK_POOL'; // 淘汰原因

// 会场类型
export const VENUE_MEET_TYPE_LIVE_BROADCAST = 7100004; // 直播CODE
